// extracted by mini-css-extract-plugin
export default {"addressCardContainer":"addressCard_addressCardContainer__R8arj","addressCardHeader":"addressCard_addressCardHeader__WXcYD","addressCardBtn":"addressCard_addressCardBtn__vglDA"};